import { useRenderToasters } from 'hooks/useRenderToasters'

/**
 * This HOC is meant to be used in Class components, where the use of the
 * useRenderToasters hook is not possible. Just wrap the component you want
 * the toasters methods to be used on.
 *
 * @param WrappedComponent The Class component to receive the toasters methods injection.
 * @returns The component with the injected props.
 */
export const withRenderToasters = (
  WrappedComponent: React.ComponentType,
): React.FC => {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const ComponentWithToasters = (props: any): JSX.Element => {
    const renderToasters = useRenderToasters()
    return <WrappedComponent renderToasters={renderToasters} {...props} />
  }

  ComponentWithToasters.displayName = `withRenderToasters(${displayName})`

  return ComponentWithToasters
}
